import {
  DoGood,
  InternalHero,
  PetLandingPageType,
  Pricing,
  Questions,
  Reviews,
  TakeBetterCare,
  ValuePoints,
  WhatIsCovered,
} from '@/components/pet';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/pet/pet-insurance/us/en';
import { useEffect } from 'react';

const extraAnalyticsParams = {
  pet_lp_type: 'pet-insurance',
  variant: 'pet-insurance',
};

export default function PetInsurancePage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('pet_landing_page.viewed', {
        ...extraAnalyticsParams,
      }),
    [],
  );

  return (
    <Layout
      headerActions={config.layout.headerActions}
      menuCheckPricesExtraAnalyticsParams={{ ...extraAnalyticsParams }}
    >
      <SEO {...config.seo} />
      <InternalHero petLandingPageType={PetLandingPageType.PetInsurance} />
      <ValuePoints petLandingPageType={PetLandingPageType.PetInsurance} />
      <WhatIsCovered petLandingPageType={PetLandingPageType.PetInsurance} />
      <TakeBetterCare petLandingPageType={PetLandingPageType.PetInsurance} />
      <Pricing petLandingPageType={PetLandingPageType.PetInsurance} />
      <Reviews petLandingPageType={PetLandingPageType.PetInsurance} />
      <Questions petLandingPageType={PetLandingPageType.PetInsurance} />
      <DoGood petLandingPageType={PetLandingPageType.PetInsurance} />
    </Layout>
  );
}
